<template>
	<div :class="classNames">
        <div :class="classNames+ '_search'">
			<div :class="classNames+ '_search_con'">
				<div :class="classNames+ '_search_con_item'">
					<span :class="classNames+ '_search_con_item_title'">
                        收益明细
                    </span>
					<el-date-picker style="width:230px;" v-model="times" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeTime" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
					</el-date-picker>
				</div>
			</div>
			<div :class="classNames+ '_search_con'">
				<div :class="classNames+ '_search_con_item'">
					<span :class="classNames+ '_search_con_item_title'">
                       结算时间
                    </span>
					<el-date-picker style="width:330px;" v-model="times2" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeTime2" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" :picker-options="pickerOptions">
					</el-date-picker>
				</div>
			</div>
			<!-- <div :class="classNames+ '_search_con_item'" style="width:160px;">
				<span :class="classNames+ '_search_con_item_title'">订单来源</span>
				<el-select v-model="come_from2" :disabled="come_from1==4 || come_from1==5">
					<el-option v-for="(item, index) in orderFromList" :label="item.label" :value="item.value" :key="index"></el-option>
				</el-select>
			</div> -->
			<div :class="classNames+ '_search_con_item'" style="width:140px;">
				<span :class="classNames+ '_search_con_item_title'">状态</span>
				<el-select v-model="searchObj.is_allocated">
					<el-option v-for="(item, index) in sceneList" :label="item.label" :value="item.value" :key="index"></el-option>
				</el-select>
			</div>
			<div :class="classNames+ '_search_con_item'" style="width:180px;" v-if="staticPath=='/'">
				<span :class="classNames+ '_search_con_item_title'">商户类型</span>
				<el-select v-model="searchObj.is_merchant">
					<el-option v-for="(item, index) in merchantList" :label="item.label" :value="item.value" :key="index"></el-option>
				</el-select>
			</div>
			<div :class="classNames+ '_oprtation'">
				<el-button type="primary" @click="searchRes">查询</el-button>
				<span class="export-text" @click="exportBtnFn">导出<i class="el-icon-arrow-right"></i></span>
			</div>
			
		</div>
		<div :class="classNames+'_con'">
			<div :class="classNames+'_con_table'">
				<el-table :data="tableListObj.data"
					:header-cell-style="{background: '#F5F7FA',color:'#454D53'}">
					<div slot="empty">
						<img :src="require(`@/assets/image/${noDataName}.png`)" style="width: 100%;padding: 115px 0;"/>
					</div>
					<el-table-column :label="item.label" :prop="item.prop" v-for="(item, index) in headerList"
						:type="item.prop" :key="index" :width="item.width">
						<template slot-scope="scope">
							<div v-if="item.prop=='behavior'">提现</div>
							<div v-else-if="item.prop=='is_allocated'">{{ is_allocatedObj[scope.row['is_allocated']].label }}</div>
							<div v-else-if="item.prop=='is_db_merchant'">{{ scope.row.is_db_merchant ? merchantObj[scope.row.is_db_merchant].label : '--' }}</div>
							<div v-else>{{scope.row[item.prop] ? scope.row[item.prop]: '--'}}</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<Pagination @change="changeSize" :total="tableListObj.total" ref="pagination" v-model="searchObj.page"  v-if="(Math.ceil(tableListObj.total / searchObj.page_size) > 1) && hardShowPagination"></Pagination>
		</div>
	</div>
</template>

<script>
	import {
		mapActions
	} from 'vuex'
	import Pagination from '@/components/pagination/pagination.vue'
	import dayjs from "dayjs";
	import { exportAboutMixin } from '@/components/mixin/mixin.js'
	export default {
		name: 'capitalIncomeList',
		mixins: [exportAboutMixin],
		data() {
			return {
				classNames: 'capitalIncomeList',
                noDataName: 'empty',
				choiceDate: '',
				pickerOptions:{
					onPick: ({ maxDate, minDate }) => {
						this.choiceDate = minDate.getTime()
						if (maxDate) {
							this.choiceDate = ''
						}
					},
					disabledDate: (time) => {
						if ((this.choiceDate) !== '') {
							const one = 90 * 24 * 3600 * 1000 // 限制90天范围
							const minTime = this.choiceDate - one
							const maxTime = this.choiceDate + one
							return time.getTime() < minTime || time.getTime() > maxTime
						}
					}
				},
                times: [],
				times2: [],
				searchObj: {
					page: 1,
					page_size: 10,
                    start_time: '',
					end_time:'',
					start_settle_time:'', // 结算开始时间
					end_settle_time: '', // 结算结束时间
					is_allocated:'', // 是否结算(状态)
					come_from: 0,
					is_merchant: '' // 商户类型(抖音平台使用)
				},
				now_come_from: 0,
				come_from1:0,
				come_from2:0,
                headerList: [
                    {
                        prop: 'order_no',
                        label: '订单编号',
                        width: 130
				    },
                    {
                        prop: 'allocate_type_name',
                        label: '行为',
                        width: 70
                    },
                    {
                        prop: 'allocate_amount',
                        label: '金额（元）',
                        width: 70
                    },
                    {
                        prop: 'allocate_date',
                        label: '时间',
                        width: 80
                    },
					{
                        prop: 'is_allocated',
                        label: '状态',
                        width: 50
                    },
					{
                        prop: 'settle_time',
                        label: '结算时间',
                        width: 100
                    },
					{
                        prop: 'is_db_merchant',
                        label: '商户类型',
                        width: 80
                    }
                ],
				merchantList: [
					{
						label: '全部',
						value: ''
					},
					{
						label: '抖音商户',
						value: 1
					},
					{
						label: '豆包账户',
						value: 2
					},
				],
				merchantObj: { // 表格商户
					1: {label: '豆包账户'},
					2: {label: '抖音商户'},
				},
				is_allocatedObj: { // 是否结算
					'1': {label: '已结算'},
					'-1': {label: '未结算'},
				},
				// orderFromList: [
				// 	{
				// 		label: '全部',
				// 		value: 0
				// 	},
				// 	{
				// 		label: '抖音',
				// 		value: 1
				// 	},
				// 	{
				// 		label: '快手',
				// 		value: 2
				// 	},
				// 	{
				// 		label: '微信',
				// 		value: 3
				// 	}
				// ],
				sceneList: [
					{
						label: '全部',
						value: ''
					},
					{
						label: '已结算',
						value: 1
					},
					{
						label: '未结算',
						value: -1
					},
				],
                tableListObj: {},
				hardShowPagination: true, // 硬性展示页签
			}
		},
		created() {
			this.initData()
			this.getapplyRecordList()
		},
		components: {
			Pagination
		},
		methods: {
			...mapActions('withdrawal', ['incomeList']),
			exportBtnFn(){
				this.exportExcel(10, this.getParams())
			},
			initData(){
				let arr = [
					{value: 1, path: '/'},
					{value: 2, path: '/ks/'},
					{value: 3, path: '/wx/'},
					{value: 4, path: '/sph/'},
					{value: 5, path: '/xhs/'},
					{value: 6, path: '/dd/'},
				]
				// let miniArr = [1,2,3]
				// let val = arr.find(item=>item.path==this.staticPath).value
				this.now_come_from = arr.find(item=>item.path==this.staticPath).value
				// this.come_from1 = miniArr.includes(val) ? 0 : val
				const currentDay = dayjs().format("YYYY-MM-DD"); //当日
				const lastday_90 = dayjs().subtract(90, 'day').format("YYYY-MM-DD") // 90天前
				this.times = [lastday_90, currentDay]
				this.changeTime()
				// 修改默认come_from2的值
				// this.come_from2 = miniArr.includes(val) ? val : 0
			},
			async getapplyRecordList(flag) {
				// this.searchObj.come_from = this.come_from1==4 || this.come_from1==5 ? this.come_from1:this.come_from2
				this.searchObj.come_from = this.now_come_from
				if(flag) {
					this.searchObj.page = 1
				}
				let res = await this.incomeList(this.getParams())
                this.tableListObj = res
				if(this.now_come_from==4){ // 视频号列表数据没有分页
					this.hardShowPagination = false
				}else{
					this.hardShowPagination = true
				}
			},
			getParams(){
				let params = {...this.searchObj}
				if(this.staticPath!='/'){
					delete params.is_merchant
				}
				return params
			},
			changeSize(size) {
				this.searchObj.page = size
				this.getapplyRecordList()
			},
            changeTime(value, a, b) {
				this.searchObj.start_time = this.times && this.times.length ? this.times[0] : ''
				this.searchObj.end_time = this.times && this.times.length ? this.times[1] : ''
			},
			changeTime2(){
				this.searchObj.start_settle_time = this.times2 && this.times2.length ? this.times2[0] : ''
				this.searchObj.end_settle_time = this.times2 && this.times2.length ? this.times2[1] : ''
			},
            searchRes() {
                this.getapplyRecordList(true)
            },
			// changeStatus(){
			// 	this.getapplyRecordList(true)
			// },
			valueToText(value, listName) {
				let obj = this[listName].find(item => item.value === value)
				return obj ? obj.label : ''
			}
		}
	}
</script>
<style lang="less">
	@classNames: capitalIncomeList;
	.@{classNames} {
		.el-table::before {
			background-color: transparent;
		}
		.el-table__header {
			width: 100%!important;
		}
		.el-table__body {
			width: 100%!important;
		}
	}
	.@{classNames}_con_table {
		.@{classNames}_empty {
			position: absolute;
			top: 0px;
			left: 0;
			width: 1000px;
			height:10px;
			background: #fff;
			z-index: 100;
		}
	}
</style>
<style lang='less' scoped>
	@classNames: capitalIncomeList;

	.@{classNames} {
		display: flex;
		flex-direction: column;
		height: 100%;
		/* overflow: hidden; */
		.@{classNames}_con {
			flex: 1;
			display: flex;
			flex-direction: column;
		}
        .@{classNames}_search {
			display: flex;
			flex-shrink: 0;
			padding-bottom: 20px;
			box-sizing: border-box;
			border-bottom: 1px solid #F8F8FB;
			flex-wrap: wrap;
			align-content: center;
			gap: 16px;
			.@{classNames}_search_con {
				display: flex;
				// margin-right:16px;
				.@{classNames}_search_con_item {
					display: flex;
					align-items: center;
					// margin-right: 16px;

					.@{classNames}_search_con_item_title {
						white-space: nowrap;
						font-size: 14px;
						color: #606266;
						margin-right: 12px;
					}
				}
			}
			.@{classNames}_oprtation{
				display: flex;
				align-items: center;
			}
			.export-text{
				font-size: 14px;
				cursor: pointer;
				color: #1989fa;
				margin-left: 20px;
			}
			.@{classNames}_search_con_item {
					display: flex;
					align-items: center;
					// margin-right: 16px;

					.@{classNames}_search_con_item_title {
						white-space: nowrap;
						font-size: 14px;
						color: #606266;
						margin-right: 12px;
					}
			}
		}
	}
	
</style>
